'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pending = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _WaitingDots = require('../WaitingDots/WaitingDots');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Pending = exports.Pending = function (_PureComponent) {
  (0, _inherits3.default)(Pending, _PureComponent);

  function Pending() {
    (0, _classCallCheck3.default)(this, Pending);
    return (0, _possibleConstructorReturn3.default)(this, (Pending.__proto__ || (0, _getPrototypeOf2.default)(Pending)).apply(this, arguments));
  }

  (0, _createClass3.default)(Pending, [{
    key: 'render',
    value: function render() {
      var children = this.props.children;


      return _react2.default.createElement(
        'div',
        { className: 'modal__body' },
        _react2.default.createElement(
          'h3',
          { className: 'text--xl' },
          children
        ),
        _react2.default.createElement(_WaitingDots.WaitingDots, null)
      );
    }
  }]);
  return Pending;
}(_react.PureComponent);

Pending.CancelReservation = function () {
  return _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'pending.cancellation',
    defaultMessage: 'Cancelling your reservation, {break} please wait...',
    values: {
      break: _react2.default.createElement('br', null)
    }
  });
};

Pending.CheckingAvailability = function () {
  return _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'pending.availability',
    defaultMessage: 'Checking availability, {break} please wait...',
    values: {
      break: _react2.default.createElement('br', null)
    }
  });
};

Pending.propTypes = {
  children: _propTypes2.default.element
};